import React, { useState, useEffect } from "react";
import { getBaseUrl } from "../../constants";
import Axios from "../../api/Axios";
import { postHistory } from "../../api/History";
import { getItem } from "../../utils/nauth";
import { Button } from "@mui/material";

const ListReviewerBtn = ({ template }: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isReviewer, setIsReviewer] = useState(false);
  const [reviewerName, setReviewerName] = useState("");

  const baseUrl = `${getBaseUrl()}/v1/templates`;
  const userEmail = getItem("email") || getItem("name") || "No name";
  const userRole = getItem("role");
  const isUserRole = () => {
    return userRole === "operator" || userRole === "admin";
  };
  const setName = () => {
    let name;
    if (localStorage.getItem("email")) {
      name = localStorage.getItem("email")?.split("@")[0];
    } else {
      name = localStorage.getItem("name");
    }
    setReviewerName(name ? name : "");
  };

  const getReviwer = async () => {
    const templateUrl = `${baseUrl}/${template.templateId}`;
    // const templateUrl = `${baseUrl}/${templates.templateId}`;

    let reviewer;
    try {
      await Axios("GET", templateUrl)
        .then((data) => {
          reviewer = data.reviewer;
          setReviewerName(reviewer);
        })
        .catch((err) => {
          console.log("getReviewr Err", err);
        });
    } catch (err) {
      console.log("getReviewer", err);
    }
    return reviewer;
  };
  const handleReviewerAssignBtnYes = async () => {
    if (!isUserRole()) {
      alert("You cannot register as a reviewer with that right.");
      return;
    }
    const targetElement = document.querySelector(
      `[data-id="${template.templateId}"]`
    );
    if ((await getReviwer()) !== "") {
      const reviewerFullName = (await getReviwer()) || "";
      targetElement?.classList.add("is-reviewer");
      const reviewer = reviewerFullName.split("@")[0];
      setReviewerName(reviewer);
      alert(
        "Someone has changed the template state\n(The review is already in progress.)"
      );
      return;
    }
    setIsLoading(true);

    const raUserName = template.author.name;
    const raUserId = template.author.sub;
    try {
      await Axios("PATCH", `${baseUrl}/${template.templateId}/reviewer`)
        .then(async () => {
          const data = {
            action: "Start Review",
            templadteId: template.templateId,
            userName: raUserName,
            userId: raUserId,
            status: "In Review -> Start Review",
          };
          await postHistory(userEmail, data).catch((err) => {
            console.log("start review err", err);
          });
          targetElement?.classList.add("is-reviewer");
          setName();
          setIsReviewer(true);
        })
        .catch((err) => {
          console.log("Start Review err", err);
        });
    } catch (error) {
      console.log("Start Review err", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setName();
  }, [isReviewer]);

  if (isReviewer) {
    return <>{reviewerName}</>;
  } else {
    return (
      <Button
        disabled={isLoading}
        onClick={handleReviewerAssignBtnYes}
        size="small"
        variant="outlined"
        sx={{
          height: "30px",
        }}
        style={{
          color: "#6666ff",
          borderColor: "#6666ff",
          fontSize: "12px",
          minWidth: "85px",
          padding: "0",
        }}
      >
        Start Review
      </Button>
    );
  }
};

export default ListReviewerBtn;
